// New color scheme based on provided structure
const colors = {
  brand: '#ec632b',

  'primary-50': '#ffedda', // Lighter orange
  'primary-lighter': '#ffcc99', // Light orange
  'primary-200': '#ffb84d', // Slightly deeper orange
  'primary-light': '#ff8a5c', // Adjusted to a more orange shade
  'primary-400': '#ff5722', // Vibrant orange
  primary: '#ec632b', // Primary color
  'primary-600': '#ff3d00', // Stronger orange
  'primary-dark': '#e03b00', // Darker orange
  'primary-800': '#c02f00', // Even darker orange
  'primary-darker': '#a02800', // Deep orange
  'primary-950': '#8a2200', // Very deep orange

  'secondary-50': '#e6c2c2', // Lightened secondary color
  'secondary-lighter': '#d8a29d', // Light variation
  'secondary-200': '#c38e7f', // Slightly deeper
  'secondary-light': '#b76c58', // Adjusted secondary light to a warmer tone
  'secondary-400': '#9c5c4a', // Deeper secondary color
  secondary: '#954425', // Original secondary color
  'secondary-600': '#8b4d3b', // Strong secondary color
  'secondary-dark': '#75402c', // Darker secondary color
  'secondary-800': '#623320', // Even darker secondary color
  'secondary-darker': '#4e2715', // Deep secondary color
  'secondary-950': '#3b1b0c', // Very deep secondary color

  'accent-50': '#ffe3e8', // Lightened accent color
  'accent-lighter': '#ffb3c1', // Soft light variation
  'accent-200': '#ff8da2', // Deeper rosy pink
  'accent-light': '#ff6b81', // Balanced vibrant pink
  'accent-400': '#ff4f67', // Stronger accent color
  accent: '#C33085', // Base accent color
  'accent-600': '#d13857', // Stronger deeper pink
  'accent-dark': '#a83043', // Darker accent color
  'accent-800': '#8b2235', // Even darker accent color
  'accent-darker': '#710f2b', // Deep accent color
  'accent-950': '#600d25', // Very deep accent color

  light: '#FBE0D5', // Light color
  darklight: '#D6D6D6', // Dark light color
  faded: '#292929', // Faded color
  fadedlight: '#b0b0b0', // Adjusted for clarity
  lightdark: '#292929', // Light dark color
  dark: '#0F0E06', // Dark color

  starter: '#ff6b81',
  booster: '#ff8a5c',
  teambooster: '#ec632b',
  pro: '#C33085',

  'success-lighter': '#d1fadf', // Success lighter color
  'success-light': '#e6f7ec', // Success light color
  success: '#22c55e', // Success color
  'success-dark': '#1f975b', // Success darker color
  'success-darker': '#166534', // Success darker color
  destructive: '#A20030', // Destructive color
  danger: '#dc2626', // Danger color
  error: '#dc2626', // Error color
  warning: '#f97316', // Warning color
  highlight: '#FFEB3B', // Highlight color (bright yellow)
};

module.exports = colors;
